var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('WPBaseButton',{staticClass:"wp-button",attrs:{"elevation":"0","outlined":_vm.outlined,"disabled":_vm.disabled || _vm.loading,"fab":_vm.fab},on:{"click":_vm.onButtonClick}},[(_vm.loading)?_c('VIcon',{attrs:{"size":"28","color":"grey"}},[_vm._v(" mdi-loading mdi-spin ")]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }